export class FieldExtractor {

    static extractObjectField(data: object | null, fieldName: string | null, defaultValue: object | null =null, lowerCaseFirstLetter: boolean=false): object | null
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: object | null = defaultValue;
        if(value != null)
        {
            if(lowerCaseFirstLetter)
            {
                result = FieldExtractor.toFirstLowerCase(value);
            } else {
                result = value;
            }
        }
        return result;
    }

    private static toFirstLowerCase(value: any)
    {
        let temp: any = {};
        for(let key of Object.keys(value))
        {
            let newKey = key[0].toLowerCase() + key.slice(1);
            if(value[key] != null && typeof value[key] === 'object' && !Array.isArray(value[key]))
            {
                temp[newKey] = FieldExtractor.toFirstLowerCase(value[key]);                
            }
            else if(Array.isArray(value[key]))
            {
                temp[newKey] = FieldExtractor.extractArrayObjectField(value, key, null, true);
            }
            else {
                temp[newKey] = value[key];
            }
            
        }
        return temp;
    }

    static extractArrayObjectField(data: object | null, fieldName: string, defaultValue: object[] | null =null, lowerCaseFirstLetter: boolean=false): object[] | null
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: object[] | null = defaultValue;
        if(value != null && Array.isArray(value))
        {
            if(lowerCaseFirstLetter)
            {
                result = [];
                for(let v of value)
                {
                    if(typeof v === 'string' || v instanceof String || typeof v == 'number')
                    {
                        result.push(v as object);
                    }
                    else
                    {
                        result.push(this.extractObjectField(v, null, null, lowerCaseFirstLetter) || {});
                    }
                }
            }
            else
            {
                result = value;
            }
        }
        return result;
    }

    static extractFirstElementOrNull(data: object, fieldName: string): object | null
    {
        let arrayObj = FieldExtractor.extractArrayObjectField(data, fieldName);
        let result: object | null = null;
        if(arrayObj != null && arrayObj.length > 0)
        {
            result = arrayObj[0];
        }
        return result;
    }

    static extractJSONField(data: object, fieldName: string, defaultValue: object | null =null): object | null
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: object | null = defaultValue;
        if(value != null)
        {
            try{
                result = JSON.parse(value);
            } catch(err){}
        }
        return result;
    }

    static extractStringField(data: object, fieldName: string, defaultValue: string | null=null): string | null
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: string | null = defaultValue;
        if(value != null)
        {
            result = value;
        }
        return result;
    }

    static extractBooleanField(data: object, fieldName: string, defaultValue: boolean=false): boolean
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: boolean = defaultValue;
        if(value != null)
        {
            result = value;
        }
        return result;
    }

    static extractIntegerField(data: object, fieldName: string, defaultValue: number=0): number
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: number = defaultValue;
        if(value != null)
        {
            result = parseInt(value);
            if(!FieldExtractor.validateNumber(result))
            {
                result = defaultValue;
            }
        }
        return result;
    }

    static extractFloatField(data: object, fieldName: string, defaultValue: number=0): number
    {
        let value = FieldExtractor.extractRawValueField(data, fieldName);
        let result: number = defaultValue;
        if(value != null)
        {
            result = parseFloat(value);
            if(!FieldExtractor.validateNumber(result))
            {
                result = defaultValue;
            }
        }
        return result;
    }

    static extractDateField(data: any, fieldName: string, defaultValue: Date | null=null): Date | null
    {
        let value: number = FieldExtractor.extractRawValueField(data, fieldName);
        let result: Date | null = defaultValue;
        if(value != null)
        {
            result = new Date(data[fieldName]);
            if(!FieldExtractor.validateDate(result))
            {
                result = defaultValue;
            }
        }
        return result;
    }

    static extractDurationString(data: any, fieldName: string, defaultValue: number | null=null): number | null
    {
        let value: string | null = FieldExtractor.extractRawValueField(data, fieldName);
        let result: number | null = defaultValue;
        if(value != null)
        {
            let regex = /(\d{2})\:(\d{2}):(\d{2})/;
            let match = value.match(regex);
            if(match?.length == 4)
            {
                result = ( ( (parseInt(match[1]) * 60 ) + parseInt(match[2])) * 60 + parseInt(match[3]) ) * 1000;
            }
        }
        return result;
    }

    static extractIdFieldFromJSON(rawJson: string, fieldNames: string[]) {
        let json: object = FieldExtractor.parseJSON(rawJson);
        let result = null;
        if (json != null) {
            while (!result && fieldNames.length > 0) {
                let fieldName = fieldNames.pop()!;
                result = FieldExtractor.extractIntegerField(json, fieldName, undefined);
            }

        }
        return result;
    }

    static extractStringFieldFromJSON(rawJson: string, fieldNames: string[]) {
        let json: object = FieldExtractor.parseJSON(rawJson);
        let result: string | null = null;
        if (json != null) {
            while (!result && fieldNames.length > 0) {
                let fieldName = fieldNames.pop()!;
                result = FieldExtractor.extractStringField(json, fieldName, null);
            }

        }
        return result;
    }

    private static parseJSON(content: string) {
        let result = null;
        if (typeof content == "string") {
            try {
                result = JSON.parse(content);
            }
            catch (err) { }
        }
        return result;
    }

    private static extractRawValueField(data: any, fieldName: string | null)
    {
        let result: any = null;
        if(fieldName != null && data != null)
        {
            let fieldPath = fieldName.split('/').reverse();
            while(fieldPath.length > 0 && data != null)
            {
                let currentField = fieldPath.pop();
                if(currentField)
                {
                    data = data[currentField];
                } else {
                    break;
                }
            }
        }
        if(data !== null && typeof data !== "undefined")
        {
            result = data;
        }
        return result;
    }

    private static validateNumber(value: number): boolean
    {
        let result = true;
        if(value == null || isNaN(value))
        {
            result = false;
        }
        return result;
    }

    private static validateDate(value: Date): boolean
    {
        let result = false;
        if (Object.prototype.toString.call(value) === "[object Date]") {
            result = true;
        }
        return result;
    }
}